import React, { useState, useCallback } from "react";
import Select from "react-select";
import debounce from "lodash.debounce";

const DynamicDropdown = ({ 
  apiUrl, 
  label, 
  placeholder, 
  value, 
  onChange, 
  formatOption 
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch dropdown options
  const fetchOptions = async () => {
    setLoading(true);
    setError(null);

    try {
      console.log(`Fetching data from ${apiUrl}`);
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      console.log("Fetched data:", data);

      // Check if response is an array
      if (Array.isArray(data)) {
        setOptions(data.map(formatOption));
      } else {
        throw new Error("Invalid API response format");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setOptions([]);
      setError("Failed to load options");
    } finally {
      setLoading(false);
    }
  };

  // Debounce API calls
  const debouncedFetchOptions = useCallback(debounce(fetchOptions, 500), []);

  return (
    <div>
      <label>{label}</label>
      <Select
        options={options}
        isLoading={loading}
        onMenuOpen={debouncedFetchOptions} // Fetch options when dropdown opens
        onChange={onChange}
        value={options.find((opt) => opt.value === value) || null}
        placeholder={placeholder}
        isClearable
        noOptionsMessage={() => error || "No results found"}
      />
    </div>
  );
};

export default DynamicDropdown;

